query ListMessageRequests(
  $id: ID!
  $first: Int
  $last: Int
  $after: String
  $before: String
  $query: String
  $queryList: [QueryItemInput!]
) {
  messageRequestsForAccount(
    accountId: $id
    first: $first
    last: $last
    after: $after
    before: $before
    query: $query
    queryList: $queryList
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        type

        insertedAt
        updatedAt
        processedAt
        deliveredAt

        hostNumber
        remoteNumber

        direction

        status
        errorCode

        displayBody

        remoteMessagingEnabled
        remoteReferenceId
        remoteCountryCode
        remoteTier

        account {
          id
          name
        }
      }
    }
  }
}
